"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7243],{

/***/ 87243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ deleteFavoriteJob; },
/* harmony export */   "AV": function() { return /* binding */ submitDeactivation; },
/* harmony export */   "Cp": function() { return /* binding */ changePassword; },
/* harmony export */   "Dl": function() { return /* binding */ postLeadforms; },
/* harmony export */   "Hr": function() { return /* binding */ saveAlerts; },
/* harmony export */   "LB": function() { return /* binding */ deleteAlerts; },
/* harmony export */   "Mo": function() { return /* binding */ auSubmitEnquiry; },
/* harmony export */   "NR": function() { return /* binding */ getUserGrades; },
/* harmony export */   "Nd": function() { return /* binding */ submitReferees; },
/* harmony export */   "OT": function() { return /* binding */ requestWhitepaperSending; },
/* harmony export */   "Qh": function() { return /* binding */ sendBasicInfo; },
/* harmony export */   "R7": function() { return /* binding */ getReferees; },
/* harmony export */   "TI": function() { return /* binding */ getJobGrades; },
/* harmony export */   "WC": function() { return /* binding */ resendEmail; },
/* harmony export */   "YY": function() { return /* binding */ claimRewards; },
/* harmony export */   "ZW": function() { return /* binding */ getResumeInfo; },
/* harmony export */   "ZX": function() { return /* binding */ getPreferredWorkLocations; },
/* harmony export */   "_z": function() { return /* binding */ withdrawJobApplication; },
/* harmony export */   "c3": function() { return /* binding */ updateUserSession; },
/* harmony export */   "cY": function() { return /* binding */ updateTermsVersion; },
/* harmony export */   "e3": function() { return /* binding */ isUserExisting; },
/* harmony export */   "et": function() { return /* binding */ getUserProfile; },
/* harmony export */   "gL": function() { return /* binding */ addFavoriteJob; },
/* harmony export */   "hZ": function() { return /* binding */ getSpecialities; },
/* harmony export */   "hi": function() { return /* binding */ submitMotivatorQuestions; },
/* harmony export */   "i9": function() { return /* binding */ submitOnboarding; },
/* harmony export */   "iJ": function() { return /* binding */ submitProfile; },
/* harmony export */   "jc": function() { return /* binding */ getImportantGoals; },
/* harmony export */   "m$": function() { return /* binding */ uploadCV; },
/* harmony export */   "n5": function() { return /* binding */ getSubSpecialitiesV2; },
/* harmony export */   "oi": function() { return /* binding */ submitBookAppointment; },
/* harmony export */   "rE": function() { return /* binding */ getRegisterOrgData; },
/* harmony export */   "sJ": function() { return /* binding */ submitRegister; },
/* harmony export */   "uW": function() { return /* binding */ getRootSpecialtiesV2; },
/* harmony export */   "uu": function() { return /* binding */ updateAlerts; },
/* harmony export */   "yW": function() { return /* binding */ submitEnquiry; }
/* harmony export */ });
/* unused harmony exports apiRoute, makeRequestAndNoticeErrors, makeRequest, makeExternalRequest, getJobGradesV2, submitApply */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25892);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26626);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clientErrorInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54787);










var apiRoute = "/api";
var UseRequestError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(UseRequestError, Error1);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(UseRequestError);
    function UseRequestError() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, UseRequestError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(args)));
        if (Error.captureStackTrace) {
            Error.captureStackTrace((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this), UseRequestError);
        }
        _this.name = "useRequest Error";
        return _this;
    }
    return UseRequestError;
}((0,_swc_helpers_src_wrap_native_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Error));
var noticeError = function(err) {
    try {
        if (false) { var message, parsedData, ref1, email, ref, tryToNoticeError; } else {
            (0,_clientErrorInfo__WEBPACK_IMPORTED_MODULE_7__.tryToNoticeClientError)(err);
        }
    } catch (sentryErr) {
        console.error("There was an error trying to send to Sentry: ", sentryErr);
    }
};
/**
 * Make a request to a Medrecruit API via the /api page proxy
 * Internally reports errors without any helpful context; avoid using in new code
 * @description: makeRequestAndNoticeErrors({url: 'XXXXX', data: {}})
 * @return { response, error }
 */ var makeRequestAndNoticeErrors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(axiosConfig) {
        var _tmp, err, ref;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    _tmp = {};
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()(axiosConfig)
                    ];
                case 1:
                    return [
                        2,
                        (_tmp.response = _state.sent(), _tmp)
                    ];
                case 2:
                    err = _state.sent();
                    noticeError(err);
                    return [
                        2,
                        {
                            error: ((ref = err.response) === null || ref === void 0 ? void 0 : ref.data) || err
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function makeRequestAndNoticeErrors(axiosConfig) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Make a request to a Medrecruit API via the /api page proxy
 * Does _not_ report any errors; consumers should do this if appropriate
 * @description: makeRequestAndNoticeErrors({url: 'XXXXX', data: {}})
 * @return { response, error }
 */ var makeRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(axiosConfig) {
        var _tmp, err, ref;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    _tmp = {};
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()(axiosConfig)
                    ];
                case 1:
                    return [
                        2,
                        (_tmp.response = _state.sent(), _tmp)
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        2,
                        {
                            error: ((ref = err.response) === null || ref === void 0 ? void 0 : ref.data) || err
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function makeRequest(axiosConfig) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Make a request to some API that is not the medrecruit backend
 * // TODO allow typing and conversion of response and error
 * @return { response, error }
 */ var makeExternalRequest = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(axiosConfig) {
        var response, error, err, ref;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default()(axiosConfig)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    err = _state.sent();
                    noticeError(err);
                    error = ((ref = err.response) === null || ref === void 0 ? void 0 : ref.data) || err;
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        {
                            response: response,
                            error: error
                        }
                    ];
            }
        });
    });
    return function makeExternalRequest(axiosConfig) {
        return _ref.apply(this, arguments);
    };
}();
var isUserExisting = function(email) {
    return makeRequest({
        method: "post",
        url: "".concat(apiRoute, "/users/check-user-exists"),
        data: {
            email: email
        }
    });
};
var sendBasicInfo = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/users/reserve"),
        data: data
    });
};
var submitRegister = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/users/register"),
        data: data
    });
};
var resendEmail = function(email) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/users/send-email-verification"),
        data: {
            email: email
        }
    });
};
var uploadCV = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/users/resume"),
        data: data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
var changePassword = function(data) {
    return makeExternalRequest({
        method: "post",
        url: "".concat(apiRoute, "/change-password"),
        data: data
    });
};
var addFavoriteJob = function(id) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/jobs/").concat(id, "/favourite")
    });
};
var deleteFavoriteJob = function(id) {
    return makeRequestAndNoticeErrors({
        method: "delete",
        url: "".concat(apiRoute, "/jobs/").concat(id, "/favourite")
    });
};
var saveAlerts = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/alerts"),
        data: data
    });
};
var deleteAlerts = function(id) {
    return makeRequestAndNoticeErrors({
        method: "delete",
        url: "".concat(apiRoute, "/alerts/").concat(id)
    });
};
var updateAlerts = function(id, data) {
    return makeRequestAndNoticeErrors({
        method: "put",
        url: "".concat(apiRoute, "/alerts/").concat(id),
        data: data
    });
};
/**
 * Return the Grades that users can be associated with, via registration and their profile
 */ var getUserGrades = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/picklist/grades")
    });
};
/**
 * Return the Grades that jobs can be associated with
 */ var getJobGrades = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        makeRequestAndNoticeErrors({
                            url: "".concat(apiRoute, "/picklist/grades")
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result) {
                        return [
                            2,
                            result.response.data.filter(function(grade) {
                                return grade.key !== "Medical Student";
                            })
                        ];
                    }
                    throw result.error;
            }
        });
    });
    return function getJobGrades() {
        return _ref.apply(this, arguments);
    };
}();
var getSpecialities = function(grade) {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/picklist/").concat(encodeURIComponent(grade), "/specialities")
    });
};
// V2 grade | speciality | subspeciality functions
/**
 * Get's the job grades from the v2 endpoint
 *
 * @returns {Promise<Array<IGrade>>} - The job grades
 */ var getJobGradesV2 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        makeRequestAndNoticeErrors({
                            url: "".concat(apiRoute, "/v2/picklist/grades")
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result) {
                        return [
                            2,
                            result.response.data.filter(function(grade) {
                                return grade.key !== "Medical Student";
                            })
                        ];
                    }
                    throw result.error;
            }
        });
    });
    return function getJobGradesV2() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get's the root specialities based on job grade from the v2 endpoint
 *
 * @param {JobGrade} grade - The job grade
 * @returns {Promise<Array<IRootSpecialityV2>>} - The root specialities available for the job grade
 */ var getRootSpecialtiesV2 = function(grade) {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/v2/picklist/grades/").concat(encodeURIComponent(grade), "/specialties")
    });
};
/**
 * Get's the sub specialities based on job grade and root speciality from the v2 endpoint
 *
 * @param {JobRootSpecialtyV2} rootSpeciality - The job specialty
 * @returns {Promise<Array<ISubSpeciality>>} - The sub specialities available for the given specialty
 */ var getSubSpecialitiesV2 = function(grade, rootSpeciality) {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/v2/picklist/grades/").concat(encodeURIComponent(grade), "/specialties/").concat(encodeURIComponent(rootSpeciality), "/subspecialties")
    });
};
var getPreferredWorkLocations = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/picklist/preferred-work-locations")
    });
};
var getRegisterOrgData = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/picklist/registration-org")
    });
};
var getImportantGoals = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/picklist/important-goals")
    });
};
var submitProfile = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/profile"),
        data: data
    });
};
var withdrawJobApplication = function(jobId) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/jobs/").concat(jobId, "/withdraw")
    });
};
var submitReferees = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/referees"),
        data: data
    });
};
var getReferees = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/referees")
    });
};
var submitApply = function(id, data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/jobs/").concat(id, "/apply"),
        data: data
    });
};
var submitEnquiry = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(jobNumber) {
        var ref, result, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        makeRequest({
                            method: "POST",
                            url: "".concat(apiRoute, "/jobs/").concat(jobNumber, "/apply")
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result) {
                        ;
                        return [
                            2,
                            {
                                status: (ref1 = result.response.data) === null || ref1 === void 0 ? void 0 : ref1.status
                            }
                        ];
                    }
                    throw new Error("Error while enquiring for the job. Cause '".concat((ref = result.error) === null || ref === void 0 ? void 0 : ref.message, "'"));
            }
        });
    });
    return function submitEnquiry(jobNumber) {
        return _ref.apply(this, arguments);
    };
}();
var auSubmitEnquiry = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var jobNumber, hasAhpra, ahpraNumber, ref, result, ref1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    jobNumber = param.jobNumber, hasAhpra = param.hasAhpra, ahpraNumber = param.ahpraNumber;
                    return [
                        4,
                        makeRequest({
                            method: "POST",
                            url: "".concat(apiRoute, "/jobs/").concat(jobNumber, "/apply"),
                            data: {
                                hasAhpra: hasAhpra,
                                ahpraNumber: ahpraNumber
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result) {
                        ;
                        return [
                            2,
                            {
                                status: (ref1 = result.response.data) === null || ref1 === void 0 ? void 0 : ref1.status
                            }
                        ];
                    }
                    throw new Error("Error while enquiring for the job. Cause '".concat((ref = result.error) === null || ref === void 0 ? void 0 : ref.message, "'"));
            }
        });
    });
    return function auSubmitEnquiry(_) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Request that the named whitepaper is delivered to the current logged in user
 * @param paperName the name (rather than slug) of a whitepaper
 */ var requestWhitepaperSending = function(paperName) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/whitepapers/").concat(paperName)
    });
};
var submitDeactivation = function() {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/users/deactivate")
    });
};
var updateTermsVersion = function(newVersion) {
    return makeRequestAndNoticeErrors({
        method: "put",
        url: "".concat(apiRoute, "/accept-latest-terms"),
        data: {
            newVersion: newVersion
        }
    });
};
var claimRewards = function() {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/users/claim-rewards")
    });
};
var getResumeInfo = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/users/resume")
    });
};
var getUserProfile = function() {
    return makeRequestAndNoticeErrors({
        url: "".concat(apiRoute, "/users/profile")
    });
};
var postLeadforms = function(data) {
    return makeRequestAndNoticeErrors({
        method: "post",
        url: "".concat(apiRoute, "/leadforms"),
        data: data
    });
};
/**
 * Submits a user's answers to a set of motivation questions that are found on the dashboard
 */ var submitMotivatorQuestions = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(data) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        makeRequest({
                            method: "POST",
                            url: "".concat(apiRoute, "/users/motivators/type/MotivatorsV1"),
                            data: data
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result && result.response.status === 201) {
                        return [
                            2,
                            result.response.data
                        ];
                    }
                    throw new Error("Error while submitting motivator questions");
            }
        });
    });
    return function submitMotivatorQuestions(data) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Submits a request to a Solution Specialist for an appointment on a certain day at a specified time
 */ var submitBookAppointment = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(data) {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        makeRequest({
                            method: "POST",
                            url: "".concat(apiRoute, "/users/book-appointment"),
                            data: data
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result && result.response.status === 202) {
                        return [
                            2,
                            result.response.data
                        ];
                    } else if ("error" in result) {
                        throw new Error("Error while submitting request for appointment", result.error);
                    }
                    throw new Error("Error while reading api response after submitting request for appointment");
            }
        });
    });
    return function submitBookAppointment(data) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Updates the user session after the user is created in Medrecruit
 */ var updateUserSession = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        makeRequest({
                            method: "get",
                            url: "".concat(apiRoute, "/update-user-session")
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ("response" in result && result.response.status === 200) {
                        return [
                            2,
                            result.response.data
                        ];
                    }
                    // FIXME error handling
                    throw new Error("Error while updating user session");
            }
        });
    });
    return function updateUserSession() {
        return _ref.apply(this, arguments);
    };
}();
var submitOnboarding = function(data) {
    return makeRequest({
        method: "post",
        url: "".concat(apiRoute, "/users/onboarding"),
        data: data
    });
};


/***/ })

}]);